export default function(elem: Element, win: Window = window) {
	const rect = elem.getBoundingClientRect();

    const winHeight = (win.innerHeight || document.documentElement.clientHeight);
    const winWidth = (win.innerWidth || document.documentElement.clientWidth);

    const vertInView = (rect.top <= winHeight) && ((rect.top + rect.height) >= 0);
    const horInView = (rect.left <= winWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
};